import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NgModel, Validators } from '@angular/forms';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import * as _ from 'lodash';
import { NgFor, NgIf } from '@angular/common';

interface LogicCondition {
  interaction: string;
  comparisonOptr: string;
  target: string;
  value: any;
  targetInteraction: string;
  configuration: any[];
  isValid: boolean;
  isOpen: boolean;
  logicalOptr: string;
}

interface Question {
  text: string;
  field_id: string;
  group_id?: string;
  group_text?: string;
  options?: Question[];
  interaction_type?: string;
  allowMultiSelect?: boolean;
  readOnly?: boolean;
  prop?: any[];
  is_primary_rating?: boolean;
  is_primary_comment?: boolean;
}

interface QuestionGroup {
  text: string;
  field_id: string;
  options: Question[];
}

@Component({
  selector: 'app-interaction-setup-options',
  templateUrl: './interaction-setup-options.component.html',
  styleUrls: ['./interaction-setup-options.component.scss'],
  standalone:true,
  imports:[NgFor,NgIf,FormsModule]
})
export class InteractionSetupOptionsComponent implements OnInit {
  @Input() interaction: any;
  @Input() readOnly: boolean = false;
  @Output() onChange: any = new EventEmitter<any>()

  conditionForOptionSelected: 'display' | 'custom' = 'display';
  showDisplay = true;
  showCustom = false;
  isDisplayConditionActive = true;
  isCustomConditionActive = false;
  currentQuestion: any;

  componentConditions = {
    logicDetail: {
      "1": {
        "logicString": null,
        "logicKey": "1",
        "editMode": false,
        "transformString": [],
        "transformOrignal": []
      },
      "2": {
        "logicString": null,
        "logicKey": "2",
        "editMode": false,
        "transformString": [],
        "transformOrignal": []
      },
      "3": {
        "logicString": null,
        "logicKey": "3",
        "editMode": false,
        "transformString": null,
        "transformOrignal": null
      }
    },
    logicAction: "1"
  };




  subQuestionMap: any = {}

  /* default condtion actions */
  actions: any = {
    '1': {
      value: "1",
      text: "Show",
      actionProperty: 'visible-if'
    },
    '2': {
      value: "2",
      text: "Mandatory",
      actionProperty: 'is_mandatory_if',
    },
    '3': {
      value: "3",
      text: "Server Visible",
      actionProperty: 'server-visible-if',
    }
  };

  /**
   * @name operators
   * @description  for storing  operators 
   * @type {Object}  logical{Object} , comparison{Object}
   * @note please make sure comparison object must be descending sorted order as comparison.text length.  
   **/
  operators: any = {
    logical: [{
      op: "||",
      text: "OR"
    }, {
      op: "&&",
      text: "AND"
    }],
    comparison: [{
      op: ">=",
      text: "Greater than Equals"
    }, {
      op: "<=",
      text: "Less than Equals"
    }, {
      op: ">",
      text: "Greater than"
    }, {
      op: "<",
      text: "Less than"
    }, {
      op: "!=",
      text: "Not Equals"
    }, {
      op: "==",
      text: "Equals"
    }]
  };

  operatorsMap = {
    "||":"OR",
    "&&":"AND",
    '==': 'equals',
    "!=": 'not equals',
    ">": 'greater than',
    "<": 'greater than or equal',
    ">=": 'less than',
    "<=": 'less than or equal',
  };


  questionConditions: any = {}
  questions: any = []
  questionMaps: any = { }
  logicAction: any = '1';
  logicDetailsMap: any = {}
  isEditMode: boolean = false;
  isLogicAvailable: boolean = false;
  subQuestionFieldId: any = null;
  subQuestionIndex: any = -1
  questionFields: any = null


  constructor(private fb: FormBuilder, private _conversations: ConversationService) { }

  ngOnInit() {
    this.initializeQustions()
    if (!_.isEmpty(this.interaction)) {
      _.each(this.interaction.sub_questions, (option: any) => {
        this.questionMaps[option.field_id] = {
          questions: this.getFilteredQuestions(this.interaction, null, this.logicAction),
          values: []
        }
        this.initialize(option.field_id, this.logicAction)
      })
    }




    this.subQuestionMap = {}
    this.initializeConditions();
  }


  initializeQustions() {
    this.questions = [];
    if (_.get(this._conversations, 'configuration.fields')) {
      var fields = _.cloneDeep(this._conversations.configuration.fields);
      _.each(fields, (field) => {
        var interactionType = _.get(field, 'interaction_type');
        if (interactionType != 'label' && interactionType != 'image' && !field.hasOwnProperty('readOnly')) {
          if (field.hasOwnProperty('group_id') && field.hasOwnProperty('group_text') && (field.interaction_type == 'multi-select')) {
            this.questions.push(field);
          } else if (!field.hasOwnProperty('group_id') && !field.hasOwnProperty('group_text') && !_.get(field, 'allowMultiSelect')) {
            this.questions.push(field);
          }
        }
      });
    }
  }


  getFilteredQuestions(currentQuestion: any, targetField: any, action?: any): (Question | QuestionGroup)[] {
    let questions = _.filter(_.cloneDeep(this.questions), (question: Question) => {
      if ((currentQuestion && currentQuestion.field_id && question.field_id && (currentQuestion.field_id == question.field_id)) || (question.group_id && (question.group_id == currentQuestion.field_id))) {
        if (action == '2' && (question.group_id == currentQuestion.field_id)) {
          return true;
        } else {
          return false;
        }
      }
      if (targetField && targetField == _.get(question, 'field_id')) {
        return false;
      }
      return true;
    })
    let groups: { [key: string]: Question | QuestionGroup } = {}
    _.each(questions, (question: Question) => {
      if (question.group_text) {
        if (!groups[question.group_id!]) {
          groups[question.group_id!] = {
            text: question.group_text,
            field_id: question.group_id!,
            options: []
          } as QuestionGroup
        }
        if(groups[question.group_id!] && !groups[question.group_id!]?.options ){
          groups[question.group_id!].options = [];
        }
        (groups[question.group_id!] as QuestionGroup).field_id = question.group_id!;
        (groups[question.group_id!] as QuestionGroup).text = question.group_text;
        (groups[question.group_id!] as QuestionGroup).options.push(question)
      } else {
        groups[question.field_id] = question
      }
    });
    return Object.values(groups)
  }



  initialize(fieldId, logicAction, optionDetails?: any) {
    if (fieldId) {
      this.subQuestionFieldId = fieldId;
      this.findIndexForSubQuestion(fieldId);
      if (!this.logicDetailsMap[fieldId]) {
        this.logicDetailsMap[fieldId] = Helpers.deepClone(this.componentConditions)
      }
      if (optionDetails && optionDetails.logicDetail) {
        this.logicDetailsMap[fieldId].logicDetail = optionDetails.logicDetail;
      }
    }
    this.editCondition(fieldId, logicAction, true);
    setTimeout(() => {
      this.newExpression(fieldId, '1');
      this.newExpression(fieldId, '2');
      this.newExpression(fieldId, '3');
    }, 400);
  }

  findIndexForSubQuestion(fieldId) {
    if (_.get(this.interaction, 'sub_questions')) {
      var index = _.findIndex(this.interaction.sub_questions, {
        'field_id': fieldId
      });
      if (index >= 0) {
        this.subQuestionIndex = index;
      }
    }
  }


  newExpression(fieldId: string, logicAction: any) {
    if (this.logicDetailsMap[fieldId].logicDetail && this.logicDetailsMap[fieldId].logicDetail[logicAction] && this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString) {
      _.each(this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString, function (expression) {
        if (expression.isOpen) {
          expression.isOpen = false;
        }
      });
    }
    const transformString = _.get(this.logicDetailsMap[fieldId], 'logicDetail.' + logicAction + '.transformString', [])
    if (_.isEmpty(transformString) && _.isArray(transformString)) {
      // this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString.push(this.getQueryStringObject({}));
    }

    this.setQuestions();
  };


  /**
   * @name  setQuestions
   * @description  set questions object array from conversation designer parent
   *  
   **/
  setQuestions() {
    this.setCurrentQuestion();
    this.questions = [];
    if (_.get(this._conversations, 'configuration.fields')) {
      var fields = Helpers.deepClone(this._conversations.configuration.fields);
      _.each(fields, (field: any) => {
        var interactionType = _.get(field, 'interaction_type');
        if (interactionType != 'label' && interactionType != 'image' && !field.hasOwnProperty('readOnly')) {
          if (field.hasOwnProperty('group_id') && field.hasOwnProperty('group_text') && (field.interaction_type == 'multi-select')) {
            this.questions.push(field);
          } else if (!field.hasOwnProperty('group_id') && !field.hasOwnProperty('group_text') && !_.get(field, 'allowMultiSelect')) {
            this.questions.push(field);
          }
        }
      });
    }
  }




  /**
   * @name  setCurrentQuestion
   * @description  set current question object from conversation designer parent
   * 
   **/
  setCurrentQuestion() {
    this.currentQuestion = null;
    if (_.get(this.interaction, 'sub_questions[' + this.subQuestionIndex + ']')) {
      this.currentQuestion = this.interaction.sub_questions[this.subQuestionIndex];
    }
  }

  /**
    * @name  editCondition
    * @description edit the condition of interaction for show/Mandatory/Server Visible 
    * and convert condition string in to [getQueryStringObject]
    * @param {string} logicAction - logic action['1'|'2'] for show or mandatory condition
    *
    */
  editCondition(fieldId, logicAction, noNewLogic) {

    if (logicAction) {
      this.isEditMode = true;
    }



    this.setQuestions();
    this.setQuestionConditions();
    // resetComponentConditions();
    this.copyQuestionConditions(fieldId);

    this.logicAction = logicAction ? logicAction : '1';
    var currentParentQuestion = this.interaction;
    // looop through each actions {Show, Mandatory, Server Visible}
    _.each(this.logicDetailsMap[fieldId].logicDetail, (logic: any, index: any) => {
      //true for show and mandatory actions and is edit mode true
      //if we have server visible i.e logicKey is 3 then provide logic string as it is 
      if (logic.logicKey != 3) {
        if (_.get(logic, 'transformString') && _.get(logic, 'logicString') && (logic.transformString.length == 0) && (typeof logic.logicString == 'string')) {
          var expressions = logic.logicString;
          var checkChildBracket = expressions.indexOf('((');
          if (checkChildBracket !== 1) {
            /**
             * Removing brackets for getting the proper expression
             * for displaying data in the modal popup
             */
            expressions = expressions.replace(/\(\(/g, "");
            expressions = expressions.replace(/\)\)/g, "");
          }

          // expressions = expressions.replace(/ *\([^)]*\) */g, "");
          var lastBracketIndex = expressions.lastIndexOf('(');
          if (lastBracketIndex !== -1) {
            expressions = expressions.substring(0, lastBracketIndex);
            if (expressions && expressions.length > 2) {
              var isOperator = expressions.slice(-2);
              if (isOperator === '&&') {
                expressions = expressions.substring(0, expressions.length - 2);
              }
            }
          }
          //split string on OR | AND as a seperator 
          // var expressions = logic.logicString.split(/\&\&|\|\|/);
          expressions = expressions.split(/\&\&|\|\|/);
          //remove logic expresstion from string for getting AND & OR operator array
          var conditions = _.compact(logic.logicString.match(/(&&)?(\|\|)*/g));
          if (expressions.length) {
            //loop through expressions getting from logic string
            _.each(expressions, (expression, index) => {
              //assign logical operator if not a first operator
              var logicalOperator = index > 0 ? conditions[index - 1] : '||';
              //create object from sring
              var stringObject = this.createObjectFromExpression(expression, logicalOperator);
              stringObject.logicString = this.getFormatedLogicString(stringObject);
              if (stringObject.configuration && stringObject.value) {
                const config = _.find(stringObject.configuration, (config: any) => {
                  return stringObject.value == config.value;
                });
                stringObject.value = config?.value || '';
              }
              stringObject.isOpen = false;
              var isValidity = this.formValidity(stringObject);
              stringObject.isValid = (isValidity) ? true : false;
              //push above created query string object in transform string array of respective action 
              if (stringObject.isValid) {
                logic.transformString.push(stringObject);
              }
              //if edit mode is true then set it to false
              if (!logic.editMode) {
                //copying string transform object to array variable
                logic.transformOrignal.push(Helpers.deepClone(stringObject));
              }
            });
          } else {
            logic.transformString = [this.getQueryStringObject({})];
          }
          //set sub action editmode to true
          logic.editMode = true;
        }
        //  else if (!noNewLogic) {
        //     //logic string is empty then initialize query string object
        //     logic.transformString = [getQueryStringObject({})];
        // }
      } else {
        var expressions = logic.logicString;
        if (expressions) {
          var parentQueExpressions = currentParentQuestion['server-visible-if'];
          if (parentQueExpressions) {
            parentQueExpressions = '(' + parentQueExpressions + ')';
            var indexOfParentExp = expressions.indexOf(parentQueExpressions);
            if (indexOfParentExp !== -1) {
              expressions = expressions.substring(0, indexOfParentExp);
              if (expressions && expressions.length > 2) {
                var isOperator = expressions.slice(-2);
                if (isOperator === '&&') {
                  expressions = expressions.substring(0, expressions.length - 2);
                }
              }
              this.logicDetailsMap[fieldId].logicDetail[index].logicString = expressions;
            }
          }
        }
      }
    });
    this.isLogicAvailable = true;
  };


  /*
         * @name  createObjectFromExpression
         * for e.g. condition string:
         *      (detailed_rating['question_9436981327']<=2)
         *  condition object string :
         *  
         *  queryStringObject: {
         *   interaction: 'question_9436981327';
         *   comparisonOptr: '<=';
         *   target: 'target_Field';
         *   value: '2';
         *   targetInteraction: null
         *   logicalOptr: 'OR';
         *   configuration: [{value: 1, text'Very Poor'},
         *                  {value: 2, text'Poor'},
         *                  {value: 3, text'Good'}]}]
         * @description create getQueryStringObject object for action's logic transform string from string expression, asssigning logical operator 
         * @param {string} expression - expression string 
         * @param {string} logicalOperator - logical operator for e.g. ['&&'|'||'] 
         *  
         */
  createObjectFromExpression(expression, logicalOperator) {
    //initialize query string object with target and logical operator property
    var queryStringObject = this.getQueryStringObject({});

    //compaire operator.comparison with the string for picking up expression operator
    _.each(this.operators.comparison, (comparisonOptr: any, index: any) => {
      //true if operator found in a string
      if (expression.lastIndexOf(comparisonOptr.op) > -1) {
        //assigning question in the object 
        queryStringObject.interaction = expression.substr(0, expression.lastIndexOf(comparisonOptr.op) - 1);
        //getting question parameter of selected question and assign it to configuration
        queryStringObject.configuration = this.getQuestionParameters(queryStringObject.interaction);
        //split expresson on the basis of coparison operator
        var literals = expression.split(comparisonOptr.op);
        //assigning question in the object
        switch (literals[0]) {
          case 'rating.primary_rating':
            queryStringObject.interaction = 'primary_rating';
            break;
          case 'rating.comments':
            queryStringObject.interaction = 'comments';
            break;
          default:
            queryStringObject.interaction = literals[0].substr(24).slice(0, -2);
        }

        //getting question parameter of selected question and assign it to configuration
        queryStringObject.configuration = this.getQuestionParameters(queryStringObject.interaction);
        var targetString = literals[1];
        queryStringObject.target = 'target_field';

        //assigning target question/value in the object
        switch (literals[1]) {
          case 'rating.primary_rating':
            queryStringObject.targetInteraction = 'primary_rating';
            break;
          case 'rating.comments':
            queryStringObject.targetInteraction = 'comments';
            break;
          default:
            if (this.isInteraction(targetString)) {
              //assign to query string object
              //removing "rating.detailed_rating['']" from logic string 
              queryStringObject.targetInteraction = literals[1].substr(24).slice(0, -2);
            } else {
              queryStringObject.target = 'target_value';
              //remove blank spaces from string splited above and assign to query string object
              queryStringObject.value = targetString;
            }
        }
        //assign comparison operator
        queryStringObject.comparisonOptr = comparisonOptr.op;
        queryStringObject.logicalOptr = logicalOperator;
        //returning from loop
        return false;
      }
      return true;
    });

    return queryStringObject;
  };

  /**
   * @name  getQuestionParameters
   * @description set question parameter for question/interaction options as configuration object
   * @param {string} fieldId - field id
   * @returns {[Object]|null} - configuration parameter or null
   */
  getQuestionParameters(fieldId: string) {
    var question = this.getQuestionByFieldId(fieldId);
    if (_.get(question, 'prop')) {
      return _.map(question.prop, (prop: any) => {
        return prop;
      });
    } else {
      return null;
    }
  };

  /**
    * @name  getQuestionByFieldId
    * @description  getting question object from parent in this case conversation designer
    * @param {string} fieldId - field id 
    * @return {Object} - Question object from conversation designer 
    **/
  getQuestionByFieldId(fieldId: string): any {
    this.questionFields = null;
    if (_.get(this._conversations, 'configuration.fields')) {
      switch (fieldId) {
        case 'primary_rating':
          this.questionFields = _.find(this._conversations.configuration.fields, {
            is_primary_rating: true,
            field_id: fieldId
          });
          break;
        case 'comments':
          this.questionFields = _.find(this._conversations.configuration.fields, {
            is_primary_comment: true,
            field_id: fieldId
          });
          break;
        default:
          this.questionFields = _.find(this._conversations.configuration.fields, {
            field_id: fieldId
          });
      }
    }
    return this.questionFields;
  };


  /** 
    * @name  isInteraction
    * @description check whether given string is question/interaction or not
    * @param {string} fieldId - field id
    * @return {boolean} - true is value is question/interaction else false
    *  
    */
  isInteraction(fieldId: string): boolean {
    var question = undefined;
    if (_.get(this._conversations, 'configuration.fields')) {
      question = _.find(this._conversations.configuration.fields, {
        'field_id': fieldId
      });
    }
    return (typeof question === 'object');
  };

  getFormatedLogicString(queryObject: any) {
    var logicStr = '';
    var targetInteractionQuestion = '';
    var interactionId = [];

    if (queryObject.value && isNaN(queryObject.value) && queryObject.value.indexOf("rating.") > -1) {
      if (queryObject.value.indexOf("primary_rating") > -1) {
        queryObject.targetInteraction = 'primary_rating';
      } else {
        interactionId = queryObject.value.split("['");
        if (interactionId[interactionId.length - 1]) {
          let text: string = interactionId[interactionId.length - 1]
          queryObject.targetInteraction = text.replace("']", '');
        }
      }

      queryObject.target = 'target_field';
    }

    _.each(this.questions, (questions) => {
      if (queryObject.interaction && questions.field_id) {
        if (questions.field_id == queryObject.targetInteraction && queryObject.target == 'target_field') {
          targetInteractionQuestion = questions.question;
        }

        if (questions.field_id === queryObject.interaction) {
          logicStr = logicStr + (questions.question || '') + '  ' + (queryObject.comparisonOptr || '') + '  ';
        }
      }
    });


    if (queryObject.configuration && (!queryObject.targetInteraction || !(queryObject.target == 'target_field'))) {
      for (var j = 0; j < queryObject.configuration.length; j++) {
        if (queryObject.configuration[j].value && queryObject.value) {
          if (queryObject.configuration[j].value == queryObject.value) {
            logicStr = logicStr + '"' + (queryObject.configuration[j].label || '') + '"';
            break;
          }
        }
      }
    } else {
      logicStr = logicStr + ' "' + targetInteractionQuestion + '"';
    }

    return logicStr;
  }

  formValidity(logic) {
    logic.target = logic.target || 'target_value';
    if (logic.interaction && logic.comparisonOptr && logic.target) {
      if (logic.target == 'target_value' || logic.target == 'target_field') {
        if (logic.value || logic.targetInteraction) {
          return true;
        }
      }
    }
    return false;
  }










  /**
   * @name  setQuestionConditions
   * @description  getting all question conditions from parent in this case conversation designer 
   * @type {Object} - logicDetail{Object} , logicAction{number} 
   **/
  setQuestionConditions() {
    this.questionConditions = {};
    _.each(this.actions, (action) => {
      if (_.get(this.interaction, 'sub_questions[' + this.subQuestionIndex + '].' + action.actionProperty)) {
        var optionCondtionString = this.interaction.sub_questions[this.subQuestionIndex][action.actionProperty];
        var questionCondtionString = this.interaction[action.actionProperty];
        if (optionCondtionString.indexOf('&&' + questionCondtionString) !== -1) {
          optionCondtionString = optionCondtionString.replace('&&' + questionCondtionString, '');
        }
        if (optionCondtionString !== questionCondtionString) {
          this.questionConditions[action.actionProperty] = optionCondtionString;
        }
      }
    });
  };

  /*
   * @name  copyQuestionConditions
   * @description copying conditions to local instance from parent instance in this case conversation designer 
   * 
   */
  copyQuestionConditions(fieldId: string) {
    _.each(this.logicDetailsMap[fieldId].logicDetail, (action) => {
      if (_.get(this.questionConditions, this.actions[action.logicKey].actionProperty)) {
        action.logicString = this.questionConditions[this.actions[action.logicKey].actionProperty];
      }
    });
  };




  /*
    * @name getQueryStringObject
    * @typedef {Object} getQueryStringObject
    * @property {Object.string} interaction - interaction
    * @property {Object.string} comparisonOptr - comparison operator string
    * @property {Object.string} target - target field or target value
    * @property {Object.string} value - value compairing with question input
    * @property {Object.string} logicalOptr - logical operator string
    * @property {Object[Object]} configuration - configuration for the parameter
    * @return {Object} stringObject - query string object 
    **/
  getQueryStringObject(queryStringObject: any) {
    var stringObject: any = {};
    stringObject.interaction = _.get(queryStringObject, 'interaction') ? queryStringObject.interaction : '';
    stringObject.comparisonOptr = _.get(queryStringObject, 'comparisonOptr') ? queryStringObject.comparisonOptr : '';
    stringObject.value = _.get(queryStringObject, 'value') ? queryStringObject.value : '';
    stringObject.targetInteraction = _.get(queryStringObject, 'targetInteraction') ? queryStringObject.targetInteraction : '';
    stringObject.logicalOptr = _.get(queryStringObject, 'logicalOptr') ? queryStringObject.logicalOptr : '||';
    stringObject.target = _.get(queryStringObject, 'target') ? queryStringObject.target : '';
    stringObject.configuration = _.get(queryStringObject, 'configuration') ? queryStringObject.configuration : [];
    stringObject.isOpen = true;
    return stringObject;
  }



  toggleConditionTab(tab: 'display' | 'custom') {
    if (this.conditionForOptionSelected != tab) {
      this.conditionForOptionSelected = tab;
      if (tab == 'display') {
        this.isCustomConditionActive = false;
        this.showCustom = false;
        // this.isDisplayConditionActive = true;
        this.showDisplay = true;
      } else if (tab == 'custom') {
        // this.isCustomConditionActive = true;
        this.showCustom = true;
        this.isDisplayConditionActive = false;
        this.showDisplay = false;
      }
    }
  }

  initializeConditions() {
    if (this.interaction?.sub_questions) {
      _.each(this.interaction.sub_questions, (question: any) => {
        this.subQuestionMap[question.field_id] = question;
      })
    }
    if (this.interaction && this.interaction.conditions) {

      this.componentConditions = this.interaction.conditions;
    }
  }



  updateConditionForLogicOpt(fieldId: string, logic: LogicCondition, operator: string) {
    logic.logicalOptr = operator;
    this.updateCurrentCondition(fieldId, 1);
  }

  getQuestionText(fieldId: string): string {
    const question = this.questions.find((q: any) => q.field_id === fieldId);
    let text = '';
    if (!_.isEmpty(question)) {
      text = (question.text) ? question.text : question.question;
    }
    return text;
  }


  /*
         * @name  updateTransitionObject
         * @description to set transition object after selecting/changing interaction
         * @param {integer} arrayIndex - index of an array
         * @param {Object} queryStringObject - queryStringObject
         * @param {string} logicAction - logic action 
         *
         */
  updateTransitionObject(fieldId, arrayIndex, queryStringObject) {
    var questionFields: any = null;
    if (queryStringObject.hasOwnProperty('interaction')) {
      questionFields = this.getQuestionByFieldId(queryStringObject.interaction);
      if (_.get(questionFields, 'prop')) {
        queryStringObject.configuration = _.map(questionFields.prop, function (prop) {
          return prop;
        });
      }
    }
    if (_.get(this.logicDetailsMap[fieldId], 'logicDetail.' + this.logicAction + '.transformString')) {
      var transitionObject = null;
      _.each(this.logicDetailsMap[fieldId].logicDetail[this.logicAction].transformOrignal, function (logic) {
        if (logic.interaction == queryStringObject.interaction) {
          transitionObject = Helpers.deepClone(logic);
          return;
        }
      });
      if (!transitionObject) {
        if (questionFields.hasOwnProperty('group_id') && questionFields.hasOwnProperty('group_text') && (_.get(questionFields, 'interaction_type') == 'multi-select')) {
          var value = null;
          if (queryStringObject.configuration && queryStringObject.configuration.length > 0) {
            value = queryStringObject.configuration[0].value.toString();
          }
          transitionObject = this.getQueryStringObject({
            interaction: queryStringObject.interaction,
            comparisonOptr: '==',
            target: 'target_value',
            value: value,
            logicalOptr: queryStringObject.logicalOptr
          });
        } else {
          var target = '';
          if (queryStringObject.configuration && queryStringObject.configuration.length > 0) {
            target = 'target_value';
          }
          transitionObject = this.getQueryStringObject({
            interaction: queryStringObject.interaction,
            configuration: queryStringObject.configuration,
            logicalOptr: queryStringObject.logicalOptr,
            target: target
          });
        }
      }

      if (this.logicDetailsMap[fieldId].logicDetail[this.logicAction].transformString.length > 0) {
        // if((this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString.length - 1) === arrayIndex) {
        //     delete transitionObject.value;
        // }
        // this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString[arrayIndex] = transitionObject;
      } else {
        this.logicDetailsMap[fieldId].logicDetail[this.logicAction].transformString.push(transitionObject);
      }

    } else {
      //console.log('no transition object found or logic action is server visible');
    }
    this.questionMaps[fieldId].values = this.getFilteredQuestions(this.interaction, queryStringObject.interaction, this.logicAction)
  }


  selectionChanged(fieldId: string, logic: LogicCondition, index: number) {
    this.updateCurrentCondition(fieldId, 1);
  }

  // addCondition(fieldId: string, logic: LogicCondition) {
  //   const newLogic: LogicCondition = {
  //     interaction: '',
  //     comparisonOptr: '',
  //     target: '',
  //     value: null,
  //     targetInteraction: '',
  //     configuration: [],
  //     isValid: false,
  //     isOpen: true,
  //     logicalOptr: 'AND'
  //   };

  //   this.logicDetailsMap[fieldId].logicDetail[1].transformString.push(newLogic);
  //   // this.updateCurrentCondition(1);
  // }
  isClickedAddCondition: boolean = false;
  emitChange: boolean = false;
  addCondition(fieldId, logic) {
    this.emitChange = true;
    if (this.formValidity(logic)) {
      this.isClickedAddCondition = true;
      logic.isValid = true;
      logic.isOpen = false;
      // updateTransitionObject($index, logic, condition.componentConditions.logicAction);
      if (logic.isOpen === false && !logic.isEditMode) {
        this.newExpression(fieldId, this.logicAction);
        if (_.get(this.logicDetailsMap[fieldId], 'logicDetail[' + this.logicAction + '].transformString')) {
          if (this.componentConditions.logicDetail[this.logicAction].transformString.length === 0) {
            console.log('ynshnthrd');
          }
        }
      }
      this.updateCurrentCondition(fieldId, this.logicAction);
      // condition.scrollDown('interactionsConditions');
    }
  }

  closeCondition(fieldId: string, index: number) {
    this.logicDetailsMap[fieldId].logicDetail[1].transformString.splice(index, 1);
    this.updateCurrentCondition(fieldId, 1);
  }

  openEditContainer(fieldId: string, logic: LogicCondition) {
    this.questionMaps[fieldId].questions = this.getFilteredQuestions(this.interaction, null, this.logicAction);
    this.questionMaps[fieldId].values = this.getFilteredQuestions(this.interaction, logic.interaction, this.logicAction);

    logic.isOpen = !logic.isOpen;


  }

  toggleForAddCondition(fieldId: string) {
    if (this.showDisplay) {
      this.subQuestionMap[fieldId]['isDisplayConditionActive'] = true;
      this.subQuestionMap[fieldId]['isCustomConditionActive'] = false;
      // this.isDisplayConditionActive = true;
      this.showCustom = false;
      // this.isCustomConditionActive = false;
    } else if (this.showCustom) {
      // this.isCustomConditionActive = true;
      // this.isDisplayConditionActive = false;
      this.subQuestionMap[fieldId]['isDisplayConditionActive'] = false;
      this.subQuestionMap[fieldId]['isCustomConditionActive'] = true;
    }
    this.logicDetailsMap[fieldId].logicDetail[this.logicAction].transformString.push({
      interaction: '',
      comparisonOptr: '',
      target: '',
      value: '',
      targetInteraction: '',
      configuration: [],
      isValid: false,
      isOpen: true,
      logicalOptr: '||'
    })




    // this.addCondition(fieldId, {
    //   interaction: '',
    //   comparisonOptr: '',
    //   target: '',
    //   value: null,
    //   targetInteraction: '',
    //   configuration: [],
    //   isValid: false,
    //   isOpen: false,
    //   logicalOptr: 'AND'
    // });
  }

  isAddButtonEnabled(fieldId:string){
    let isButtonEnabled:boolean = true;
    const transformString:any= _.get(this.logicDetailsMap,fieldId+'.logicDetail.'+this.logicAction+".transformString")
    if(!_.isEmpty(transformString) && _.isArray(transformString)){
      _.each(transformString,(logic:any)=>{
        if(logic.isOpen){
          isButtonEnabled = false
        }
      })
    }
      
    return isButtonEnabled;
  }

  /*
         * @name  updateCurrentCondition
         * @description update condition in question/interaction logic  
         * @param {string} logicAction - logic action[1|2] for show or mandatory condition
         *
         */
  updateCurrentCondition(fieldId, logicAction) {
    //data memeber for copying object string to conversation designers -> question -> logic details -> logic string 
    var logicString = '';
    //data memeber for copying object string to conversation designers -> question -> (equivalent action) 
    var logicObjectString = '';
    this.findIndexForSubQuestion(fieldId);
    //if action should not be server visible i.e. 3
    if (logicAction.toString() != '3' && _.get(this.logicDetailsMap[fieldId], 'logicDetail.' + logicAction + '.transformString')) {
      var firstCondition = true;
      _.each(this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString, (expression) => {

        if (this.isTransformStringObjectValid(expression)) {
          if (firstCondition) {
            firstCondition = false;
          } else {
            if (_.get(this.operatorsMap, expression.logicalOptr )) {
              logicObjectString += expression.logicalOptr;
              logicString += this.operatorsMap[expression.logicalOptr];
            }
          }

          var srcField = this.getQuestionByFieldId(expression.interaction);
          if (_.get(expression, 'comparisonOptr')) {
            logicObjectString += this.getInteractionFieldString(srcField) + expression.comparisonOptr;
          }

          logicString += '(' + srcField.text + ' ' + this.operatorsMap[expression.comparisonOptr] + ' ';

          if (expression.target == 'target_field') {
            var destField = this.getQuestionByFieldId(expression.targetInteraction)
            logicObjectString += this.getInteractionFieldString(destField);
            logicString += destField.text + ')';
          } else {
            if (typeof expression.value === 'string' || expression.value instanceof String) {
              logicObjectString += expression.value;
              logicString += expression.value + ')';
            } else {
              logicObjectString += expression.value.value;
              logicString += expression.value.value + ')';
            }


          }
        }
      });

    } else {
      if (_.get(this.logicDetailsMap[fieldId], 'logicDetail.' + logicAction + '.logicString')) {
        logicString = this.logicDetailsMap[fieldId].logicDetail[logicAction].logicString.trim();
        logicObjectString = this.logicDetailsMap[fieldId].logicDetail[logicAction].logicString.trim();
      }
    }
    this.addConditionString(logicAction, logicString, logicObjectString);
  };

  /**
    * @name  isTransformStringObjectValid
    * @description check whether given transition string object is valid or not
    * @param {Object} expression - string tranformation object
    * @return {boolean} - true if transition string object is valid 
    *
    **/
  isTransformStringObjectValid(expression) {
    if (expression.interaction && expression.comparisonOptr && (expression.target == 'target_field' ? expression.targetInteraction : expression.value)) {
      return true;
    }
    return false;
  }

  /**
   * @name  getInteractionFieldString
   * @description get expression question from string
   * @param {Object} question - question object having properties
   * @return {string} logicObjectString - logic object string with ID's
   **/
  getInteractionFieldString(question) {

    if (question.is_primary_rating) {
      return 'rating.primary_rating';
    } else if (question.is_primary_comment) {
      return "rating.comments";
    } else {
      return "rating.detailed_rating['" + question.field_id + "']";
    }
  };

  /**
   * @name  addConditionString
   * @description update or push logic action in connversation designers question
   * @param {string} logicAction - name of logic action
   * @param {string} logicString - logic string for logic action
   * @param {string} logicObjectString - logic object string with ID's
   **/
  addConditionString(logicAction, logicString, logicObjectString) {
    if (typeof logicString == 'string') { 
      if (_.get(this.interaction, 'sub_questions[' + this.subQuestionIndex + '].logicDetail')) {
        if (_.get(this.actions, logicAction + '.actionProperty') && logicString != '') {
          this.interaction.sub_questions[this.subQuestionIndex][this.actions[logicAction].actionProperty] = logicObjectString;
        } else {
          delete this.interaction.sub_questions[this.subQuestionIndex][this.actions[logicAction].actionProperty];
        }
        if (logicString != '') {
          this.interaction.sub_questions[this.subQuestionIndex].logicDetail[logicAction] = {
            'logicKey': logicAction,
            'logicString': logicString
          };
        } else {
          delete this.interaction.sub_questions[this.subQuestionIndex].logicDetail[logicAction];
        }

      } else {
        if (_.get(this.actions, logicAction + '.actionProperty')) {
          this.interaction.sub_questions[this.subQuestionIndex][this.actions[logicAction].actionProperty] = logicObjectString;
        }
        this.interaction.sub_questions[this.subQuestionIndex]['logicDetail'] = {};
        this.interaction.sub_questions[this.subQuestionIndex].logicDetail[logicAction] = {
          'logicKey': logicAction,
          'logicString': logicString
        };
      }
      if(this.emitChange || logicAction == 3 || logicAction == '3'){
        this.onChange.emit(this.interaction)
        this.emitChange = false;
      }
    }
  }

  isQuestionGroup(obj: Question | QuestionGroup): obj is QuestionGroup {
    return 'options' in obj && Array.isArray(obj.options);
  }

  isQuestion(obj: Question | QuestionGroup): obj is Question {
    return !('options' in obj) || !Array.isArray(obj.options);
  }
}
